<script lang="ts" setup>
import { onMounted, ref } from "vue";
import PageHeader from "@/shell/pages/layout/page-header/page-header.vue";

interface LicenseItem {
    name: string;
    text: string;
    version: string;
}

const licenses = ref<LicenseItem[]>([]);

onMounted(async () => {
    const licensesResponse = await fetch("/admin/licenses/licenses_frontend.json");
    licenses.value = await licensesResponse.json();
});

const getTitle = (name: string, version: string): string => {
    return `${name}@${version}`;
};
</script>

<template>
    <PageHeader :title="$t('shared.Licenses')" />
    <q-scroll-area class="fit q-px-lg">
        <div v-for="license in licenses" :key="getTitle(license.name, license.version)">
            <div class="bold">{{ getTitle(license.name, license.version) }}</div>
            <div class="text" v-if="license.text">
                <p v-for="(line, i) in license.text.split('\n')" :key="i">
                    {{ line }}
                </p>
            </div>
        </div>
    </q-scroll-area>
</template>

<style scoped lang="scss">
.text {
    font-family: "Open Sans";
    font-size: 12px;
}
</style>
